import {
  Container,
  LinkComponent,
  LinkContainer,
  AgentListGroup,
  RightAsideSection,
  ActivitySection,
  AgentAvatar,
  AgentDesignation,
  AgentDetails,
  AgentList,
  AgentName,
  AgentsHeaderGroup,
  AgentsSection,
  AgentsTitle,
  AnalyticsSection,
  AnalyticsTitle,
  ChartDetails,
  TableBody,
  TableData,
  TableElement,
  TableHeadElement,
  TableHeader,
  TableRule,
  TableSection,
  ViewMoreAgentsLink,
  TableHeading
} from './styles';
import real_estate_icon from '../../assets/real_estate_icon.svg';
import promotion_icon from '../../assets/promotion_icon.svg';
import hotel_icon from '../../assets/hotel_icon.svg';
import shopping_icon from '../../assets/shopping_icon.svg';
import { useNavigate } from 'react-router-dom';
import { useFetchAgentQuery } from '../../store/agent/api';
import {
  useGetAnalyticsQuery,
  useGetWeeklyActivitiesQuery
} from '../../store/dashboard/api';
import dayjs from 'dayjs';
import { generateUrl } from '../../utils/urlGenerator';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

var relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);
export const Home = () => {
  const navigate = useNavigate();
  const { data: agents } = useFetchAgentQuery();
  const { data: analytics } = useGetAnalyticsQuery();
  const { data: weeklyActivities } = useGetWeeklyActivitiesQuery(
    generateUrl({ pageSize: '10' })
  );
  ChartJS.register(ArcElement, Tooltip, Legend);
  const chartData = {
    labels: ['Real Estate', 'Shopping', 'Hotel'],
    datasets: [
      {
        label: '# of Votes',
        data: [
          analytics?.data.realEstateExpenses,
          analytics?.data.shoppingEspenses,
          analytics?.data.hotelExpenses
        ],
        backgroundColor: ['#5B93FF', '#FFD66B', '#FF8F6B']
      }
    ]
  };
  return (
    <Container>
      <LinkContainer>
        <LinkComponent
          icon={real_estate_icon}
          onClick={() => navigate('/real-estate')}
          title={'Real estate'}
          description={'Flats, Self-con, Lands'}
        />
        <LinkComponent
          icon={shopping_icon}
          onClick={() => navigate('/shopping')}
          title={'Shopping'}
          description={'Food, Drinks, Snacks'}
        />
        <LinkComponent
          icon={promotion_icon}
          onClick={() => navigate('/promotions')}
          title={'Promotions'}
          description={'Hot deals & discounts'}
        />
        <LinkComponent
          icon={hotel_icon}
          onClick={() => navigate('/hotel')}
          title={'Hotel'}
          description={'Resorts, Motels, Suites'}
        />
      </LinkContainer>
      <ActivitySection>
        <TableSection>
          <TableHeading>Recent Activities</TableHeading>
          <TableElement>
            <TableHeader>
              <TableRule>
                <TableHeadElement>S/N</TableHeadElement>
                <TableHeadElement>Category</TableHeadElement>
                <TableHeadElement>Status</TableHeadElement>
                <TableHeadElement>Time</TableHeadElement>
              </TableRule>
            </TableHeader>
            <TableBody>
              {weeklyActivities?.data.fetchedData.map(
                (recentActivity, index) => {
                  return (
                    <TableRule key={recentActivity._id}>
                      <TableData>{(index += 1)}</TableData>
                      <TableData>
                        {recentActivity.type.replace('-', ' ')}
                      </TableData>
                      <TableData>
                        {recentActivity.status.toLowerCase()}
                      </TableData>
                      <TableData>
                        {(dayjs(recentActivity.createdAt) as any).fromNow()}
                      </TableData>
                    </TableRule>
                  );
                }
              )}
            </TableBody>
          </TableElement>
        </TableSection>
        <RightAsideSection>
          <AgentsSection>
            <AgentsHeaderGroup>
              <AgentsTitle>Soji agent</AgentsTitle>
              <ViewMoreAgentsLink to="/agents">See more</ViewMoreAgentsLink>
            </AgentsHeaderGroup>
            <AgentList>
              {agents?.data.fetchedData.slice(0, 5).map((agent, index) => {
                return (
                  <AgentListGroup key={index.toString()}>
                    <AgentAvatar src={agent.file.url} />
                    <AgentDetails>
                      <AgentName>{agent.name}</AgentName>
                      <AgentDesignation>{agent.module}</AgentDesignation>
                    </AgentDetails>
                  </AgentListGroup>
                );
              })}
            </AgentList>
          </AgentsSection>
          <AnalyticsSection>
            <AnalyticsTitle>Analytics</AnalyticsTitle>
            <ChartDetails>
              <Doughnut data={chartData} />
            </ChartDetails>
          </AnalyticsSection>
        </RightAsideSection>
      </ActivitySection>
    </Container>
  );
};
